import React, { Component } from 'react';
import Container from '../../components/Container';
import { Grid, Drawer,CircularProgress, ListItem,ListItemIcon, Radio } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import { CheckIcon, VisaIcon, DeleteWhiteIcon, MasterIcon } from '../../components/icons';
import { isRetina } from '../../utils/util';
import { portalCfg } from '../../../portal.router.config';
import ButtonCustom from '../../components/ButtonCustom'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { custom_assets, domainName } from '../../../portal.config';

var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
const logo = isRetina(path+"/images/home_logo.png", path+"/images/home_logo@2x.png")

const styles = theme => ({
    method_container:{
        padding: theme.spacing(4,0,0,0)
    },
    method_pre:{
        padding:theme.spacing(0,2,0,0)
    },
    method: {
        backgroundColor:theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        height: theme.spacing(12),
        padding: theme.spacing(1,4,1,4),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]:{
            padding: theme.spacing(1,2,1,2),
        }
    },
    button_add:{
        marginTop: theme.spacing(10)
    },
    bg_icon:{
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    }
});
class CardsView extends Component {

    render() {
        const {classes, t, onCloseItem, cards, onOpenAddCard, setPrimaryCard, onRemoveCard, showLoading } = this.props
        return (
            <div>
                <DrawerCustom
                    open={this.props.open}
                    onClose={()=>onCloseItem('card')}
                    title = {t('my_cards_rewards')}
                    enableBack
                    children={                    
                        <Grid item>
                            {cards.length===0&&<Grid item xs={12}>
                                <Grid xs={12} item container justify='center'>
                                    <img src={logo}/>
                                </Grid>
                                <Grid xs={12} item container justify='center'>
                                    <CustomTypo mg_top_xl color='onPrimary' variant='body2'>{t('add_to_cart_desc')}</CustomTypo>
                                </Grid>
                            </Grid>}
                            {showLoading&&<Grid xs={12} item container justify='center'><CustomizedCircularProgress/></Grid>}
                            {cards.length>0&&cards.map((item,index)=> <CardItem key={index} item = {item} classes={classes} setPrimaryCard={setPrimaryCard} onRemoveCard = {onRemoveCard}/>)}
                            <ButtonCustom fullWidth color='primary' className={classes.button_add} onClick={onOpenAddCard} disableTextTransform>{t('add_a_card')}</ButtonCustom>
                    </Grid>}/>
        </div>
        );
    }
}
function CardItem(props){
    const {classes,item} = props
    //console.log('CardItem=== ',item)
    var card_holder_name = item.card&&item.card.card_holder_details&&item.card.card_holder_details.card_holder_name?item.card.card_holder_details.card_holder_name:""
    return(
        <Grid xs={12} item container className={classes.method_container}>
            <Grid xs={11} item className={classes.method_pre}>
                <Grid  item className={classes.method} container alignItems='center' onClick={() => props.setPrimaryCard(item.id)}>
                    <Grid xs={2} item container justify='flex-start'>
                        {item.brand === 'master' ? <MasterIcon /> : <VisaIcon />}
                    </Grid>
                    <Grid xs={8}  item>
                        <CustomTypo mg_left_sm variant='body1'>{item.card && item.card.last4 ? "**** **** **** " + item.card.last4 : ""}</CustomTypo>
                    </Grid>
                    {item.is_primary && <Grid xs={2}  item container justify='flex-end' >
                        <CheckIcon/>
                    </Grid>}
                </Grid>
            </Grid>
                <Grid xs={1} item container justify='flex-end' alignItems='center'>
                    <div className={classes.bg_icon} onClick={() => props.onRemoveCard(item)}>
                        <DeleteWhiteIcon />
                    </div>
                </Grid>
        </Grid>
    )
}
export default withStyles(styles)(withTranslation()(CardsView));